---
title: How to make Rails response faster
headline: Boost your Rails performance with Brotli compression
tags:
  - rails
  - brotli
  - ruby
date: 2022-03-22
---

The simplest way to improve your application's response performance is to compress the data with [Brotli](https://en.wikipedia.org/wiki/Brotli).

To make your Rails response faster with Brotli, you can follow these steps:

Add the required gems to your Gemfile and run `bundle install`:

```gemfile
gem 'rack-deflater'
gem 'rack-brotli'
```

In your config/application.rb file, add the following lines to enable the compression middleware:

```ruby
config.middleware.use Rack::Deflater
config.middleware.insert_before Rack::Deflater, Rack::Brotli
```

Precompile your assets by running the following command:

```bash
RAILS_ENV=production rake assets:precompile
```

This will compress your assets using Brotli and serve them with the Content-Encoding: br header, which will allow browsers that support Brotli to decompress the response and improve the loading time of your website.

## Conclusion

Brotli compression offers better compression ratios than gzip with comparable decompression speed, making it an effective way to reduce response sizes and improve page load times in Rails applications.

## References

- [How to Make Rails Response Faster](https://onlyoneaman.medium.com/how-to-make-rails-response-faster-a8cc5f1242d) by OnlyOneAman
